enum TokenConstants {
  NR_SEQ_GRUPO_CONTRATO_WEB = 'ext_nrSeqGrupoContratoWeb',
  IE_TIPO_CONTRATO          = 'ext_tipoContrato',
  MODULE                    = 'ext_module_id',
}

export default TokenConstants;
